import React from 'react';
import './PageSkeleton.css';

/**
 * PageSkeleton - Skeleton loader for page content
 * Shows a placeholder layout while page components are loading
 */
const PageSkeleton = () => {
  return (
    <div className="page-skeleton">
      {/* Hero section skeleton */}
      <div className="page-skeleton__hero">
        <div className="page-skeleton__container">
          <div className="page-skeleton__hero-content">
            <div className="skeleton skeleton--tag"></div>
            <div className="skeleton skeleton--title"></div>
            <div className="skeleton skeleton--title skeleton--title-short"></div>
            <div className="skeleton skeleton--text"></div>
            <div className="skeleton skeleton--text skeleton--text-short"></div>
            <div className="page-skeleton__buttons">
              <div className="skeleton skeleton--button"></div>
              <div className="skeleton skeleton--button"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Content section skeleton */}
      <div className="page-skeleton__section">
        <div className="page-skeleton__container">
          <div className="page-skeleton__header">
            <div className="skeleton skeleton--tag skeleton--center"></div>
            <div className="skeleton skeleton--subtitle skeleton--center"></div>
          </div>
          
          {/* Cards grid */}
          <div className="page-skeleton__grid">
            {[1, 2, 3].map((i) => (
              <div key={i} className="page-skeleton__card">
                <div className="skeleton skeleton--icon"></div>
                <div className="skeleton skeleton--card-title"></div>
                <div className="skeleton skeleton--card-text"></div>
                <div className="skeleton skeleton--card-text"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageSkeleton;
